<template>
    <div :style="!isActiveCard ? activeStyle :  { background: '#1E1E1E'}" :class="size" class="rounded-lg pt-1 content-between grid grid-cols-4">
        <div class="col-span-4 flex flex-row justify-between relative">
            <div class="rounded-r-full font-bold text-sm text-left text-white mt-4 px-3 py-1 max-w-max h-7 z-10 absolute"
            :class="getStatus(card.status, card.request_status).class">
                <span class="text-xs"> {{ getStatus(card.status, card.request_status).message }} </span>
                <em v-if="true"
                :class="getStatus(card.status, card.request_status).icon"
                class="px-1"></em>
            </div>

            <div class="text-right pl-40 ml-2 z-0">
                <img alt="Logo"
                    class="mt-2 mr-4 filter grayscale opacity-60"
                    :src="$page.props.white_label.data.logo_black"
                    width="400"
                />
            </div>

            <div v-if="!card.is_virtual" style="background:rgba(38, 86, 255, 0.9)"
            class="flex items-center rounded-2xl px-4 py-1 max-w-max h-7 z-10 absolute top-4 right-0 mb-10 mr-4"
            :class="{'absolute top-4': !isActiveCard}"
            >
                <span class="text-center text-sm text-white">Físico</span>
            </div>
        </div>
        <div
            class="text-sm text-left text-yellow-300 mt-2 px-8 py-4 flex flex-col col-span-3"
            :class="{'-mt-2': !isActiveCard}"
        >
            <div class="text-sm font-bold">**** **** **** {{ ['active', 'theft_or_loss', 'canceled' ].includes(card.status) ? card.last_4_digits : '****' }}</div>
            <div class="flex flex-col text-white">
                <div class="text-xs">Validade</div>
                <div class="text-base font-bold">
                    {{ formatExpirationDate(card.expiration_date) }}
                </div>
            </div>
            <div class="text-xs font-bold whitespace-nowrap">
                {{ card.embossing_name }}
            </div>
        </div>
        <div class="text-right px-3 col-span-1 pb-5 self-end">
            <img
                alt="Logo"
                class="mx-auto"
                src="images/Mastercard.png"
                width="50"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        card: {
            type: Object,
            default: () => ({})
        },
        size: {
            type: String,
            default: 'w-96 h-56'
        },
        isActiveCard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeStyle: {
                background: '#1E1E1E',
                opacity: 0.10000000149011612
            },
        }
    },
    computed: {
        statusColor() {
            return this.card.status === 'active' ||
            this.card.status === 'locked' ||
            this.card.status === 'canceled' ||
            this.card.status === 'thief_or_loss'
        },
        statusIcon() {
            return this.card.status === 'active' ?
            'fas fa-check' :
            this.card.status === 'canceled' ?
             'fas fa-times' :
             this.card.status === 'created' ?
             'fas fa-truck' :
            'fas fa-lock'
        }
    },
    methods: {
        formatExpirationDate(date) {
            return date ? date.substr(0, 2) + "/" + date.substr(2, 2) : '**/**';
        },
         getStatus(status, request_status) {
            if (request_status === "rejected") {
                return {
                    message: "Solicitação recusada",
                    class: "bg-red-500"
                };
            }
            switch (status) {
                case "active":
                    return {
                        message: "Ativo",
                        class: "bg-green-500",
                        icon: "ml-2 fas fa-check"
                    };
                case "locked":
                    return {
                        message: "Bloqueado",
                        class: "bg-gray-500",
                        icon: "fas fa-lock"
                    };
                case "theft_or_loss":
                    return {
                        message: "Roubo ou perda",
                        class: "bg-gray-500",
                        icon: "fas fa-lock"
                    };
                case "canceled":
                    return {
                        message: "Cancelado",
                        class: "bg-red-500",
                        icon: "fas fa-times"
                    };
                case "created":
                    return {
                        message: "Aprovado e aguardando entrega",
                        class: "bg-blue-600",
                        icon: "fas fa-truck"
                    };
                case "processing":
                    return {
                        message: "Em processamento",
                        class: "bg-blue-400",
                        icon: "fas fa-sync"
                };
                case "pre_register":
                    return {
                        message: "Aguardando análise",
                        class: "bg-yellow-500",
                        icon: "fas fa-hourglass-end"
                    };
                case "pre-register":
                    return {
                        message: "Aguardando análise",
                        class: "bg-yellow-500",
                        icon: "fas fa-hourglass-end"
                    };
                case null:
                    return {
                        message: "Nenhum cartão localizado",
                        class: "bg-gray-500"
                    };
                default:
                    return {
                        message: "Aprovado e aguardando entrega",
                        class: "bg-blue-500"
                    };
            }
        }
    },
};
</script>
